import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import { whatsappLink } from "@/constants/site";
import { seoHighlights } from "@/mocks/criacao-sites";

export default function SeoSection() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <SectionHeading
          badge="SEO"
          badgeIcon="ri-search-eye-line"
          badgeTone="accent"
          title="Seu site preparado para ser encontrado"
          description="Desde a estrutura inicial, pensamos em boas práticas de SEO para que o site tenha uma base técnica adequada para mecanismos de busca."
        />

        <div className="mt-12 grid grid-cols-1 gap-8 lg:grid-cols-[0.9fr_1.1fr] lg:items-start">
          <Reveal>
            <div className="rounded-2xl border border-background-200 bg-background-100/60 p-6 md:p-8">
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary-100/70 text-primary-700">
                <i className="ri-search-eye-line text-2xl" aria-hidden="true"></i>
              </span>
              <h3 className="mt-5 font-heading text-lg font-semibold text-foreground-950">
                Uma base técnica sólida
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                Organizamos a estrutura do site para que mecanismos de busca entendam o seu conteúdo e
                para que as ferramentas de análise ajudem você a acompanhar os resultados.
              </p>
              <a
                href={whatsappLink(
                  "Ola! Quero um site preparado para SEO, seguindo boas praticas com a NXHOST."
                )}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                Quero um site preparado para SEO
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </a>
              <p className="mt-4 text-xs leading-relaxed text-foreground-500">
                Trabalhamos com boas práticas de SEO. O posicionamento nas buscas depende de diversos
                fatores e não é garantido.
              </p>
            </div>
          </Reveal>

          <Reveal delay={120}>
            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
              {seoHighlights.map((item) => (
                <div
                  key={item}
                  className="flex items-start gap-3 rounded-lg border border-background-200 bg-background-50 px-4 py-3 text-sm font-medium text-foreground-700"
                >
                  <i className="ri-check-line mt-0.5 text-lg text-primary-600" aria-hidden="true"></i>
                  {item}
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}